// @flow
import DetailsHeader from './DetailsHeader';

export default DetailsHeader;
